var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.379,
    height: 18.379,
    viewBox: "0 0 15.379 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4304",
    width: 7.042,
    height: 7.042,
    rx: 1,
    transform: "translate(8.337)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4305",
    width: 7.042,
    height: 7.042,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4306",
    width: 7.042,
    height: 7.042,
    rx: 1,
    transform: "translate(8.337 8.337)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4307",
    width: 7.042,
    height: 7.042,
    rx: 1,
    transform: "translate(0 8.337)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a730465e87b0324927dcacb88527e4b5.svg";
export { ForwardRef as ReactComponent };